module.exports = __webpack_public_path__ + "img/shiping.11f28edc.png";